import { STORAGE_KEYS } from 'config/Constants';
import React, { createContext, useContext, useEffect, useState } from 'react';
import { ecommerce } from 'services/api/e-commerce';

const SdkRealesesContext = createContext();

export const SdkContextProvider = ({ children }) => {
    const [loading, setLoading] = useState(true);
    
    const [sdks, setSdks] = useState(() => {
        const savedSDK = localStorage.getItem(STORAGE_KEYS.SDKS_DATA);
        return savedSDK ? JSON.parse(savedSDK) : null;
    });

    const [clients, setClients] = useState(() => {
        const savedClients = localStorage.getItem(STORAGE_KEYS.CLIENTS_DATA);
        return savedClients ? JSON.parse(savedClients) : null;
    });

    const [apps, setApps] = useState(() => {
        const savedApps = localStorage.getItem(STORAGE_KEYS.APPS_DATA);
        return savedApps ? JSON.parse(savedApps) : null;
    });

    useEffect(() => {
        setLoading(false);
    }, []);
    
    const getSdkReleases = async() => {
        const response = await ecommerce.getSdkReleases();
        if (response.success && response.data) {
            if (response.data) {
                localStorage.setItem(STORAGE_KEYS.SDKS_DATA, JSON.stringify(response.data));
                setSdks(response.data)
            }
        }
        return response;
    };

    //#region CLIENTS
    const getClients = async(queryParams) => {
        const response = await ecommerce.getClients(queryParams);
        if (response.success && response.data) {
            if (response.data) {
                localStorage.setItem(STORAGE_KEYS.CLIENTS_DATA, JSON.stringify(response.data));
                setClients(response.data)
            }
        }
        return response;
    };

    const postClients = async(requestBody) => {
        const response = await ecommerce.postClients(requestBody);
        if (response.success && response.data) {
            if (response.data) {
                localStorage.setItem(STORAGE_KEYS.CLIENTS_DATA, JSON.stringify(response.data));
                setClients(response.data)
            }
        }
        return response;
    };

    const deleteClients = async(queryParams) => {
        const response = await ecommerce.deleteClients(queryParams);
        if (response.success && response.data) {
            if (response.data) {
                localStorage.setItem(STORAGE_KEYS.CLIENTS_DATA, JSON.stringify(response.data));
                setClients(response.data)
            }
        }
        return response;
    };
    //#endregion

    //#region APPS
    const getApps = async(queryParams) => {
        const response = await ecommerce.getApps(queryParams);
        if (response.success && response.data) {
            if (response.data) {
                localStorage.setItem(STORAGE_KEYS.APPS_DATA, JSON.stringify(response.data));
                setClients(response.data)
            }
        }
        return response;
    };

    const postApps = async(requestBody) => {
        const response = await ecommerce.postApps(requestBody);
        if (response.success && response.data) {
            if (response.data) {
                localStorage.setItem(STORAGE_KEYS.APPS_DATA, JSON.stringify(response.data));
                setClients(response.data)
            }
        }
        return response;
    };

    const deleteApps = async(queryParams) => {
        const response = await ecommerce.deleteApps(queryParams);
        if (response.success && response.data) {
            if (response.data) {
                localStorage.setItem(STORAGE_KEYS.APPS_DATA, JSON.stringify(response.data));
                setClients(response.data)
            }
        }
        return response;
    };
    //#region 


      //#region APPS
    const getServiceAccounts = async(queryParams) => {
        const response = await ecommerce.getServiceAccounts(queryParams);
        if (response.success && response.data) {
            if (response.data) {
                //localStorage.setItem(STORAGE_KEYS.APPS_DATA, JSON.stringify(response.data));
                //setClients(response.data)
            }
        }
        return response;
    };

    const postServiceAccounts = async(requestBody) => {
        const response = await ecommerce.postServiceAccounts(requestBody);
        if (response.success && response.data) {
            if (response.data) {
                //localStorage.setItem(STORAGE_KEYS.APPS_DATA, JSON.stringify(response.data));
                //setClients(response.data)
            }
        }
        return response;
    };

    const deleteServiceAccounts = async(queryParams) => {
        const response = await ecommerce.deleteServiceAccounts(queryParams);
        if (response.success && response.data) {
            if (response.data) {
                ///localStorage.setItem(STORAGE_KEYS.APPS_DATA, JSON.stringify(response.data));
                //setClients(response.data)
            }
        }
        return response;
    };
    //#region 

  return (
    <SdkRealesesContext.Provider value={{ 
        sdks, 
        getSdkReleases, 
        clients, 
        getClients, 
        postClients, 
        deleteClients, 
        apps,
        getApps,
        postApps,
        deleteApps,

        getServiceAccounts,
        postServiceAccounts,
        deleteServiceAccounts,


        loading 
        
        }}>
      {children}
    </SdkRealesesContext.Provider>
  );
};

// Custom hook for easy access
export const useOperational = () => useContext(SdkRealesesContext);
